export default "__VITE_ASSET__CzSSyS15__"